import { selfAxios } from "@oppein/op-utils";
/**
 * 主合同号标签分页查询
 */
export async function queryPageByOrgPermissions(params) {
  const { data } = await selfAxios.post(
    "/designordercenter/customerMainContactLabel/queryPageByOrgPermissions",
    params,
  );
  return data;
}



// WEBPACK FOOTER //
// ./src/api/designordercenter/customerMainContactLabel/queryPageByOrgPermissions/post.js